/**
 * LineItemsTable - Shared line items table for quotes and invoices
 * PROMPT 40: Financial Documents Unified View Layer
 */
export function LineItemsTable({ 
  lines = [], 
  formatCurrency,
  testIdPrefix = "line-item"
}) {
  return (
    <div className="p-6">
      <h2 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-4">
        Line Items
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full" data-testid="document-line-items">
          <thead>
            <tr className="border-b-2 border-border">
              <th className="text-left py-3 px-4 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                Description
              </th>
              <th className="text-right py-3 px-4 text-xs font-semibold text-muted-foreground uppercase tracking-wider w-24">
                Qty
              </th>
              <th className="text-right py-3 px-4 text-xs font-semibold text-muted-foreground uppercase tracking-wider w-32">
                Unit Price
              </th>
              <th className="text-right py-3 px-4 text-xs font-semibold text-muted-foreground uppercase tracking-wider w-32">
                Line Total
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {lines && lines.length > 0 ? (
              lines.map((line, index) => (
                <tr key={index} className="hover:bg-surface-elevated" data-testid={`${testIdPrefix}-${index}`}>
                  <td className="py-3 px-4 text-sm text-foreground">
                    {line.description}
                  </td>
                  <td className="py-3 px-4 text-sm text-foreground text-right font-mono">
                    {line.quantity}
                  </td>
                  <td className="py-3 px-4 text-sm text-foreground text-right font-mono">
                    {formatCurrency(line.unit_price)}
                  </td>
                  <td className="py-3 px-4 text-sm text-foreground text-right font-mono font-medium">
                    {formatCurrency(line.line_total)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="py-6 text-center text-muted-foreground italic">
                  No line items
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LineItemsTable;
